import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import client from "@/lib/api";
import { cn } from "@/lib/utils";

export function GiveawaySource({ onPick }) {
  const [mode, setMode] = useState("scratch");
  const [opts, setOpts] = useState(null);
  const [picked, setPicked] = useState("");
  useEffect(() => { if (mode === "giveaway" && !opts) client.get("/vouchers/giveaway-options").then(({ data }) => setOpts(data)).catch(() => setOpts([])); }, [mode, opts]);
  const pill = (k, l) => (
    <button type="button" onClick={() => { setMode(k); if (k === "scratch") { setPicked(""); onPick(null); } }} data-testid={`voucher-source-${k}`}
      className={cn("flex-1 rounded-md px-3 py-1.5 text-sm font-semibold", mode === k ? "bg-white text-sky-700 shadow-sm" : "text-slate-500 hover:text-slate-700")}>{l}</button>
  );
  return (
    <div className="space-y-2" data-testid="voucher-source">
      <div className="flex gap-1 rounded-lg bg-slate-100 p-1">{pill("scratch", "From scratch")}{pill("giveaway", "From a Giveaway")}</div>
      {mode === "giveaway" && (
        <select value={picked} onChange={(e) => { setPicked(e.target.value); onPick((opts || []).find((o) => o.id === e.target.value) || null); }}
          className="h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm focus:border-sky-400 focus:outline-none" data-testid="voucher-giveaway-select">
          <option value="">{opts === null ? "Loading giveaways…" : opts.length ? "Choose a giveaway…" : "No giveaways without a voucher"}</option>
          {(opts || []).map((o) => <option key={o.id} value={o.id}>{o.title}{o.end_date ? ` · ${new Date(o.end_date).toLocaleDateString("en-AU", { month: "short", year: "numeric" })}` : ""}</option>)}
        </select>
      )}
    </div>
  );
}

export function GiveawayLink({ id, title }) {
  return (
    <Link to={`/collaborations?open=${id}`} className="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700 hover:bg-amber-100" data-testid="voucher-giveaway-link">
      <Gift className="h-3.5 w-3.5" />From giveaway: {title || "Giveaway"}
    </Link>
  );
}

export function GiveawayVouchers({ collabId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { client.get("/vouchers", { params: { collab_id: collabId } }).then(({ data }) => setRows(data)).catch(() => setRows([])); }, [collabId]);
  if (!rows.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="collab-vouchers">
      <span className="text-[11px] font-bold uppercase tracking-wide text-slate-500">Prize voucher</span>
      {rows.map((v) => (
        <Link key={v.id} to={`/prize-vouchers?open=${v.id}`} className="inline-flex items-center gap-1.5 rounded-full border border-sky-200 bg-sky-50 px-2.5 py-1 text-xs font-semibold text-sky-700 hover:bg-sky-100" data-testid={`collab-voucher-link-${v.id}`}>
          <Gift className="h-3.5 w-3.5" />{v.voucher_no ? `#${v.voucher_no}` : "Voucher"}{v.gift ? ` · ${v.gift}` : ""}
        </Link>
      ))}
    </div>
  );
}
